module.exports = __webpack_public_path__ + "static/media/AnovaUI-Italic.9c665471.woff2";